import { PieChart } from '@tamagui/lucide-icons';
import { Page } from '@unistocks/components/page/page';
import { CreatePortfolioForm } from '@unistocks/features/portfolios/components/forms/create-portfolio-form';
import { PORTFOLIO } from '@unistocks/features/portfolios/portfolio-type';
import { usePortfoliosCreateMutation } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { t } from '@unistocks/shared/localization/index.ts';
import { useRouter } from 'expo-router';
import { Keyboard } from 'react-native';

export const CreatePortfolio: React.FC = () => {
  const router = useRouter();

  const { mutateAsync: createPortfolio } = usePortfoliosCreateMutation({
    onMutate: () => {
      Keyboard.dismiss();
    },
    onSuccess: ({ id }) => {
      router.replace({ pathname: '/(tabs)/portfolios/[id]', params: { id } });
    }
  });

  return (
    <Page size={'small'}>
      <Page.ScrollView
        headerLogo={false}
        headerTitle={t('::Menu:Portfolios:Create')}
        breadcrumbs={[
          {
            key: 'portfolio',
            href: { pathname: '/(tabs)/portfolios' },
            name: t('::Menu:Portfolios'),
            rootPathName: 'portfolios',
            Icon: props => <PieChart {...props} />
          }
        ]}
      >
        <Page.Content>
          <CreatePortfolioForm type={PORTFOLIO} onSubmit={createPortfolio} />
        </Page.Content>
      </Page.ScrollView>
    </Page>
  );
};

CreatePortfolio.displayName = 'CreatePortfolio';
